export enum AdjustmentSessionKind {
  Receive = "receive",
  Count = "count",
  Transfer = "transfer",
}
